
import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { TimeRange } from '@/hooks/useTimeRange';

interface TimeRangeSelectorProps {
  timeRange: TimeRange;
  onTimeRangeChange: (range: TimeRange) => void;
}

const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({
  timeRange,
  onTimeRangeChange,
}) => {
  return (
    <div className="flex bg-gray-800 rounded-full p-0.5">
      <Button 
        variant="ghost"
        size="sm"
        className={cn(
          "text-xs h-7 rounded-full px-4",
          timeRange === 'month' ? 'bg-gray-700 text-white' : 'text-gray-400'
        )}
        onClick={() => onTimeRangeChange('month')}
      >
        Month
      </Button>
      <Button 
        variant="ghost"
        size="sm"
        className={cn(
          "text-xs h-7 rounded-full px-4",
          timeRange === 'quarter' ? 'bg-gray-700 text-white' : 'text-gray-400'
        )}
        onClick={() => onTimeRangeChange('quarter')}
      >
        Quarter
      </Button>
      <Button 
        variant="ghost"
        size="sm"
        className={cn(
          "text-xs h-7 rounded-full px-4",
          timeRange === 'year' ? 'bg-gray-700 text-white' : 'text-gray-400'
        )}
        onClick={() => onTimeRangeChange('year')}
      >
        Year
      </Button>
    </div>
  );
};

export default TimeRangeSelector;
